import { useEffect, useMemo, useRef } from 'react'
import { Table } from '../../../../components/Table'
import { useInfiniteScroll } from '../../../../hooks/useInfiniteScroll'
import { useInfiniteAssetMeetingsQuery } from '../../../../services/hooks/meetings/queries/useMeetingsOnDashboardQuery'

interface Props {
  startDate: number
  endDate: number
}

export const AssetMeetingsWithInfiniteScroll = ({ startDate, endDate }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const columns = [
    {
      field: 'id',
      headerName: 'id',
      isVisible: false,
    },
    {
      field: 'name',
      headerName: 'Nome',
      widthInPercentage: 80,
    },
    {
      field: 'meetingCount',
      headerName: 'Reuniões',
      widthInPercentage: 20,
    },
  ]

  const {
    data,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useInfiniteAssetMeetingsQuery({
    page: 1,
    take: 10,
    startDate,
    endDate
  })

  const rows = useMemo(() => {
    return (
      data?.pages?.reduce((acc: any, item: any) => {
        return [...acc, ...item.data]
      }, []) || []
    )
  }, [data?.pages])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [startDate, endDate])

  return (
    <div className="flex flex-col gap-6 w-full px-4 py-6 lg:p-6 pb-2 border-solid border-grey-100 border-1 rounded-xl shadow-[0_4.74191px_11.8548px_rgba(0,0,0,0.05)]">
      <p className="text-base font-medium lg:text-lg">Reunião de Asset</p>
      {data && (
        <Table
          columns={columns}
          rows={rows}
          isLoading={isLoading}
          isFetchingNextPage={isFetchingNextPage}
          tableContainerRef={tableContainerRef}
          noContentMessage="Sem registros"
          paginationMode="scroll"
          isDashboardMeetingsTable
        />
      )}
    </div>
  )
}
